
import React from "react";
import { Schemes } from "../utils";
import { i18nManager } from "../i18n";
import { Button } from "@ronuse/noseur";
import { useSearchParams } from "react-router-dom";

function Landing() {
    const labels = i18nManager.Labels.landing;
    const [searchParams, _] = useSearchParams(window.location.search);
    const administratorLoginUrl = process.env.REACT_APP_ADMINISTRATOR_LOGIN_URL ?? "http://localhost:3000";

    return (<div className="landing">
        <div className="centered">
            <span className="title">{i18nManager.Labels.short_name}</span>
            <span className="desc">{labels.desc}</span>
            <Button text={labels.login} scheme={Schemes.RIVTN_MNEMOSYNE} onClick={() => {
                window.location.href = (`${administratorLoginUrl}?rloc=${window.location.origin}/auth?loc=${encodeURIComponent(searchParams.get("loc") ?? "/dashboard")}&rtype=auth`);
            }}/>
        </div>
    </div>);
}

export default Landing;
